import { Link } from "react-router-dom";
import { t } from "@/lib/i18n";

export default function NotFound() {
  return (
    <section className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
      <img src="/icon-192.png" alt="" className="w-24 h-24 mx-auto rounded-full floaty" />
      <h1 className="mt-8 text-4xl sm:text-5xl font-extrabold">{t("This page got recycled.")}</h1>
      <p className="mt-4 text-[var(--ink-soft)]">{t("The page you're looking for doesn't exist anymore — but your old newspapers still can have a second life.")}</p>
      <Link to="/" className="btn-leaf mt-8" data-testid="not-found-home-btn">{t("Back to home")}</Link>
    </section>
  );
}
